const roundDecimal = (num: number | string) => {
  const intNum = Number(num);
  return Math.round(intNum * 100) / 100;
};

export default roundDecimal;
